import Model from 'flarum/common/Model';

export default class Questionnaire extends Model {
  apiEndpoint() {
    return '/qwn-questionnaires' + (this.exists ? '/' + this.data.id : '');
  }
}

Object.assign(Questionnaire.prototype, {
  title: Model.attribute('title'),
  description: Model.attribute('description'),
  cover_url: Model.attribute('coverUrl'),
  instructions: Model.attribute('instructions'),
  questions: Model.attribute('questions'),
  pre_conditions: Model.attribute('preConditions'),
  post_actions: Model.attribute('postActions'),
  is_published: Model.attribute('isPublished'),
});
